/** Catálogo de defensivos do MAPA (Agrofit) e as conferências por cultura. */
export class CatalogoDefensivosFactory {
  constructor(instance) {
    this.instance = instance;
  }

  buscar(filtro) {
    return this.instance.get('/v1/catalogo-defensivos', { params: filtro || null });
  }

  detalhar(registro) {
    return this.instance.get(`/v1/catalogo-defensivos/${registro}`);
  }

  conferirAtividade(registroId) {
    return this.instance.get(
      `/v1/catalogo-defensivos/conferencia/atividade/${registroId}`,
    );
  }

  /** Baixa a bula do registro no Agrofit e lê como o PDF enviado. Não altera o insumo. */
  buscarBulaNoAgrofit(registro) {
    return this.instance.post(
      `/v1/catalogo-defensivos/${encodeURIComponent(registro)}/bula-agrofit`,
      // Corpo vazio: `null` vira o texto "null", que a API recusa como JSON.
      {},
      { timeout: 120000 },
    );
  }

  /** Lê carência (por cultura) e reentrada do PDF da bula. Não altera o insumo. */
  lerBula(arquivo, registroDoInsumo) {
    const formData = new FormData();
    formData.append('file', arquivo);
    if (registroDoInsumo) formData.append('registro_do_insumo', registroDoInsumo);
    return this.instance.post('/v1/catalogo-defensivos/bula', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  }
}
